var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewlarge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.2303 39.8854H39.3412C38.5183 39.8854 37.8457 39.2128 37.8457 38.3899V32.0929C37.8457 31.27 38.5183 30.5974 39.3412 30.5974H57.2303C58.0532 30.5974 58.7258 31.27 58.7258 32.0929V38.3899C58.7258 39.2128 58.0532 39.8854 57.2303 39.8854ZM39.9924 37.7387H56.5792V32.7369H39.9924V37.7387Z",
    fill: "#E0E0E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1897 43.5996H37.6387V45.7463H42.1897V43.5996Z",
    fill: "#00A3FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5256 43.5996H45.9746V45.7463H50.5256V43.5996Z",
    fill: "#00A3FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9338 43.5996H54.3828V45.7463H58.9338V43.5996Z",
    fill: "#00A3FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1897 49.8175H37.6387V51.9642H42.1897V49.8175Z",
    fill: "#00A3FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5256 49.8175H45.9746V51.9642H50.5256V49.8175Z",
    fill: "#00A3FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7678 49.624H55.6211V58.3754H57.7678V49.624Z",
    fill: "#00A3FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1897 56.0361H37.6387V58.1828H42.1897V56.0361Z",
    fill: "#00A3FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5256 56.0361H45.9746V58.1828H50.5256V56.0361Z",
    fill: "#00A3FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6453 40.0283H8.99414V42.175H33.6453V40.0283Z",
    fill: "#00A3FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4527 63.5563H35.1128C33.7103 63.5563 32.5654 62.4186 32.5654 61.0089V27.9499C32.5654 26.5474 33.7032 25.4025 35.1128 25.4025H61.4527C62.8552 25.4025 64.0001 26.5402 64.0001 27.9499V61.0089C64.0001 62.4186 62.8552 63.5563 61.4527 63.5563ZM35.1128 27.5563C34.891 27.5563 34.7121 27.7352 34.7121 27.957V61.0161C34.7121 61.2379 34.891 61.4168 35.1128 61.4168H61.4527C61.6746 61.4168 61.8534 61.2379 61.8534 61.0161V27.957C61.8534 27.7352 61.6746 27.5563 61.4527 27.5563H35.1128Z",
    fill: "#00A3FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1127 63.5563H0V0H40.78L53.4741 12.6941V26.483H51.3274V13.5814L39.8927 2.14669H2.14669V61.4097H35.1127V63.5563Z",
    fill: "#00A3FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4014 14.2111H39.2637V1.07336H41.4104V12.0644H52.4014V14.2111Z",
    fill: "#00A3FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3519 50.6619H8.99414V52.8086H25.3519V50.6619Z",
    fill: "#00A3FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9694 29.3524H16.8228V32.3864H18.9694V29.3524Z",
    fill: "#2DCDAF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9694 9.11633H16.8228V12.0716H18.9694V9.11633Z",
    fill: "#2DCDAF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4562 30.4257H16.3435C13.4741 30.4257 11.1413 28.1573 11.1413 25.3666H13.288C13.288 26.9695 14.6619 28.279 16.3435 28.279H19.4562C21.3309 28.279 22.8623 26.8192 22.8623 25.0303C22.8623 24.1716 22.5116 23.3559 21.8819 22.7477C21.2379 22.1251 20.3792 21.7817 19.4633 21.7817H16.3506C13.288 21.7817 10.7979 19.3631 10.7979 16.3863C10.7979 14.9409 11.3775 13.5813 12.4365 12.5581C13.4812 11.5491 14.8766 10.991 16.3506 10.991H19.4633C22.3327 10.991 24.6655 13.2593 24.6655 16.05H22.5188C22.5188 14.4471 21.1449 13.1377 19.4633 13.1377H16.3506C15.4347 13.1377 14.576 13.4811 13.932 14.1037C13.2952 14.7191 12.9517 15.5276 12.9517 16.3863C12.9517 18.1752 14.483 19.635 16.3578 19.635H19.4705C20.9445 19.635 22.3327 20.1931 23.3846 21.2021C24.4436 22.2253 25.0233 23.5849 25.0233 25.0303C25.0089 28.0071 22.5188 30.4257 19.4562 30.4257Z",
    fill: "#2DCDAF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewlarge);
export default __webpack_public_path__ + "static/media/newlarge.13823b4ec380b9d9b184758c7d8ee562.svg";
export { ForwardRef as ReactComponent };